var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#document_svg__a)",
    stroke: "currentColor",
    strokeWidth: 2.721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.77 38.194 6.259-6.259a1.831 1.831 0 0 0 0-2.592l-2.908-2.908a1.831 1.831 0 0 0-2.592 0l-6.26 6.26c-.344.344-.536.81-.536 1.295v4.741h4.74c.486 0 .952-.192 1.297-.537v0ZM13.066 25.898h7.333M13.066 16.731h14.667M35.066 18.564v-5.5a5.5 5.5 0 0 0-5.5-5.5H11.233a5.5 5.5 0 0 0-5.5 5.5v16.5a5.5 5.5 0 0 0 5.5 5.5h9.166"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "document_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.233 .232)",
    d: "M0 0h44v44H0z"
  })))));
};

export default SvgDocument;